import clsx from 'clsx';
import React from 'react';
import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core';

import useDesktop from '@hooksV2/useDesktop';
import { useBoligmappaPlusSubscriptionStatus } from '@/store/hooks/useBoligmappaPlusSubscriptionStatus';
import Header from '../../Header';
import Container from '../../Container';
import {
  sGetActiveProperty,
  sGetDocumentsToSigned,
  sGetOwnedProperties,
  sGetSharedPrivatelyProperties,
} from '../../../store/reducers/properties';
import styles from './style';
import MenuHorizontal from '../../../assets/icons/MenuHorizontal';

const Page = ({
  classes,
  children,
  propertySelectLayout,
  homeLayout,
  topLevelLayout,
  activeProperty,
  documentsToSigned,
  ownedProperties,
  sharedProperties,
  headerSearch,
  isSearching,
  setHeaderHeight,
  fetchingProperties,
  fetchingPropertiesError,
  headerTitle,
  className,
  contentClass,
  publicSection,
  onMenuIconClick,
  subPageHeader = false,
  hideHeader = false,
  root = false,
  maxWidth = 'xl',
}) => {
  const isDesktop = useDesktop();
  const isBoligmappaPlusUser = useBoligmappaPlusSubscriptionStatus();
  return (
    <div className={clsx(className, classes.container, root && classes.root)}>
      {isDesktop && subPageHeader && (
        <div className={classes.subPageHeader}>
          <h2 className={classes.pageHeader}>{headerTitle}</h2>
          <div className={classes.editButtonsBlock}>
            {onMenuIconClick && (
              <button
                className={classes.editItemButton}
                type="button"
                onClick={onMenuIconClick}
                aria-label="Menu Horizontal"
              >
                <MenuHorizontal />
              </button>
            )}
          </div>
        </div>
      )}
      {!hideHeader && !publicSection && (
        <Header
          isDesktop={isDesktop}
          headerTitle={headerTitle}
          propertySelectLayout={propertySelectLayout}
          homeLayout={homeLayout}
          topLevelLayout={topLevelLayout}
          setHeaderHeight={setHeaderHeight}
          headerSearch={headerSearch}
          isSearching={isSearching}
          activeProperty={
            activeProperty ||
            (ownedProperties?.length > 0 && ownedProperties[0]) ||
            (sharedProperties?.length > 0 && sharedProperties[0])
          }
          documentsToSigned={documentsToSigned}
          ownedProperties={ownedProperties}
          sharedProperties={sharedProperties}
          publicSection={publicSection}
          fetching={fetchingProperties}
          error={fetchingPropertiesError}
        />
      )}
      <Container
        maxWidth={maxWidth}
        className={clsx(
          contentClass,
          classes.withHeaderContent,
          isBoligmappaPlusUser && 'subscribed'
        )}
      >
        {children}
      </Container>
    </div>
  );
};

const mapStateToProps = (state) => ({
  activeProperty: sGetActiveProperty(state),
  documentsToSigned: sGetDocumentsToSigned(state),
  ownedProperties: sGetOwnedProperties(state),
  sharedProperties: sGetSharedPrivatelyProperties(state),
});

export default connect(mapStateToProps)(withStyles(styles)(Page));
